import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './settings-dialog.controller';
import template from './settings-dialog.html';


class dialogService {
  getOptions($event, { settings }) {
    return {
      controller,
      controllerAs: 'settingsDialogVM',
      locals: {
        settings
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.oversight.settingsDialog', [
  alerts,
  oversightDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .service('oversightSettingsDialog', dialogService)
  .name;
